import { ReactNode } from "react";

import { jobViewActionsTestIds } from "@/lib/data-test-ids/jobs.data-test-ids";
import { cn } from "@/lib/utils";

interface JobViewActionsViewProps {
  className?: string;
  interestMessage: string;
  buttons: ReactNode[];
  titleId?: string;
}

export default function JobViewActionsView({
  className,
  interestMessage,
  buttons,
  titleId = "job-view-actions-title",
}: JobViewActionsViewProps) {
  return (
    <section
      aria-labelledby={titleId}
      className={cn(
        "w-full border-t border-b border-line-faint py-2 h-auto",
        className,
      )}
      data-testid={jobViewActionsTestIds.JOB_VIEW_ACTIONS}
    >
      <div className="flex flex-1 flex-col justify-center gap-4">
        <div className="space-y-1">
          <h3 id={titleId} className="text-sm font-bold text-foreground mb-1">
            Apply for this job
          </h3>
          <p className="text-xs text-ink-subtle mb-0">{interestMessage}</p>
        </div>
        <div className="flex flex-col gap-2.5">{buttons}</div>
      </div>
    </section>
  );
}
